// Single source of truth for runtime browser config.
//
// Production: the container renders /config.js from env at startup (see
// docker-entrypoint.sh + config.template.js), which sets window.__APP_CONFIG__.
// Local dev (`npm run dev`): window.__APP_CONFIG__ is empty (public/config.js),
// so we fall back to Vite's build-time .env — the dev workflow is unchanged.
//
// One built image now runs every environment; the API URL is injected at deploy
// time via the API_BASE_URL env var instead of being baked at build.

const injected =
  (typeof window !== 'undefined' && window.__APP_CONFIG__) || {}

export const API_BASE_URL =
  injected.API_BASE_URL || import.meta.env.VITE_API_BASE_URL || ''

export const APP_SECRET_KEY =
  injected.APP_SECRET_KEY || import.meta.env.VITE_APP_SECRET_KEY || ''

// Deploy environment. Only prod injects "production" (values-prod); dev, staging
// and local (`npm run dev`) resolve to "development", so environment-gated dev
// affordances stay visible everywhere except prod. Runtime, NOT build-time —
// `import.meta.env.DEV` is only true under `vite dev`, so a promoted build (dev
// cluster included) reads it as false; this flag is what actually distinguishes
// prod from the other deployed environments.
export const APP_ENV =
  injected.APP_ENV || import.meta.env.VITE_APP_ENV || 'development'

export const IS_PROD = APP_ENV === 'production'
